import { faCircleArrowDown, faCircleArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ShowMoreLessProps {
  maxHeight: number;
  selector: string;
  mobileOnly?: boolean;
}

const ShowMoreLess: FC<ShowMoreLessProps> = ({ maxHeight, selector, mobileOnly }) => {
  const [t] = useTranslation();
  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const shown = (mobileOnly && window.innerWidth < 768) || !mobileOnly;

  useEffect(() => {
    if (shown) {
      const element = document.querySelector(selector) as HTMLElement;
      setHeight(element.offsetHeight);
      element.style.maxHeight = `${maxHeight}px`;
      element.style.overflow = 'hidden';
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onClick = () => {
    const element = document.querySelector(selector) as HTMLElement;
    element.style.maxHeight = open ? `${maxHeight}px` : 'none';
    setOpen(!open);
  };

  return (
    <Fragment>
      {height > maxHeight && shown && (
        <div className="cur-poi mt-10" onClick={onClick}>
          <FontAwesomeIcon
            className="mr-5 text-contrast"
            icon={open ? faCircleArrowUp : faCircleArrowDown}
          />
          {t(open ? 'show_less' : 'show_more')}
        </div>
      )}
    </Fragment>
  );
};

export default ShowMoreLess;
